import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../constants/html'
import { getQaSelector } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import { FloatingTooltip, FloatingTooltipContentText } from '../../../Floating'
import { Link } from '../../../Link'
import {
  ENTITY_PROFILE_TAB_UPDATES_LINK_PROTOCOLS,
  QA_NAME_ENTITY_PROFILE_TAB_UPDATES_ENTITY_LINK,
} from '../EntityProfileTabUpdates.constants'

import * as styles from './EntityProfileTabUpdatesCardEntityLink.module.css'

function EntityProfileTabUpdatesCardEntityLink({ children, to }) {
  const { t } = useTranslation()

  if (!to) {
    return children
  }

  const isProtocol = ENTITY_PROFILE_TAB_UPDATES_LINK_PROTOCOLS.some(protocol =>
    to.startsWith(protocol)
  )

  const qaProps = getQaSelector({
    value: QA_NAME_ENTITY_PROFILE_TAB_UPDATES_ENTITY_LINK,
  })

  const link = (
    <Link
      {...qaProps}
      className={styles.link}
      target={isProtocol ? undefined : HTML_LINK_TARGET.blank}
      to={to}
      onClick={stopPropagation}
    >
      {children}
    </Link>
  )

  // mailto/tel links open a contact action, not a profile — no profile tooltip.
  return isProtocol ? (
    link
  ) : (
    <FloatingTooltip
      content={
        <FloatingTooltipContentText
          additionalText={t('Common.ClickToOpenProfileKey')}
          text={children}
        />
      }
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      {link}
    </FloatingTooltip>
  )
}

export default EntityProfileTabUpdatesCardEntityLink
